import "react-toastify/dist/ReactToastify.css";

import axios from "axios";
import logger from "./logService";
import { toast } from "react-toastify";

axios.interceptors.response.use(null, error => {
    if (error.code === "ERR_NETWORK")
        toast.error("خطای برقراری ارتباط شبکه");
    else if (error.response.status === 401)
        toast.error("خطای احراز هویت");
    else {
        const expectedError =
            error.response &&
            error.response.status >= 400 &&
            error.response.status < 500;
            if (!expectedError) {
                logger.log(error);
                toast.error("خطای سمت سرور");
            }
    }
    return Promise.reject(error);
});

export function getPublicConfig() {
    try {
        const config = {
            "Content-Type": 'application/json;charset=utf-8',
            "Accept": 'application/json'
        };
        return config;
    } catch (ex) {
        return null;
    }
}


export function getAuthorizedConfig() {
    try {
        const config = {
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": 'application/json;charset=utf-8',
                "Accept": 'application/json'
            }
        };
        return config;
    } catch (ex) {
        return null;
    }
}

export function getCaptchaConfig() {
    try {
        const config = {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*'
        };
        return config;
    } catch (ex) {
        return null;
    }
}

export default {
    get: axios.get,
    post: axios.post,
    put: axios.put,
    delete: axios.delete,
    getPublicConfig,
    getAuthorizedConfig,
    getCaptchaConfig
};
